
























































































import { Component, Emit, Mixins, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import { VForm } from "@/types";
import {
  SameBuildingGroup,
  DefaultSameBuildingGroup
} from "#/model/uniquemaster";

@Component
export default class SameBuildingGroupDialog extends Mixins(AxiosMixin) {
  @Ref("form") private readonly form!: VForm;

  private headers = [
    {
      text: "グループ名",
      value: "name",
      align: "start"
    },
    {
      text: "",
      value: "actions",
      align: "end",
      sortable: false
    }
  ];

  private search = "";

  private itemPerPage = 25;

  private pageNo = 1;

  private groups: SameBuildingGroup[] = [];

  private editingItem: SameBuildingGroup = DefaultSameBuildingGroup();

  private listDialog = false;

  private editDialog = false;

  private get IsDelete(): boolean {
    return this.editingItem.id !== 0;
  }

  private changePage(pageNo: number) {
    this.pageNo = pageNo;
  }

  //一覧ダイアログを開く
  public open() {
    this.search = "";
    this.pageNo = 1;
    this.listDialog = true;
    this.fetchGroups();
  }

  //グループ一覧取得
  private fetchGroups(callback?: () => void) {
    this.postJsonCheck(
      window.base_url + "/api/master/same_building_groups/get",
      {},
      res => {
        this.groups = res.data.same_building_groups;
        if (callback) callback();
      }
    );
  }

  //編集ダイアログを開く（新規）
  private openNew() {
    this.editingItem = DefaultSameBuildingGroup();
    this.editDialog = true;
    this.$nextTick(() => {
      this.form.resetValidation();
    });
  }

  //編集ダイアログを開く（編集）
  private openEdit(item: SameBuildingGroup) {
    this.editingItem = { ...item };
    this.editDialog = true;
    this.$nextTick(() => {
      this.form.resetValidation();
    });
  }

  //保存処理
  private async save() {
    if (!this.form.validate()) {
      return;
    }
    if (!(await this.$openConfirm("保存しますか？"))) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/master/same_building_group/save",
      {
        same_building_group: this.editingItem
      },
      () => {
        this.editDialog = false;
        this.fetchGroups(() => {
          this.finishSave();
        });
      }
    );
  }

  //削除処理
  private async remove() {
    if (!(await this.$openConfirm("削除しますか？"))) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/master/same_building_group/delete",
      {
        same_building_group: this.editingItem
      },
      () => {
        this.editDialog = false;
        this.fetchGroups(() => {
          this.finishSave();
        });
      }
    );
  }

  //保存完了
  @Emit()
  private finishSave() {
    return;
  }
}
